import { memo } from 'react';
import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { clearFilters } from '../../actions/FiltersActions';
import { clearSearchTerms } from '../../actions/SearchTermsActions';
import { jsx as _jsx } from "react/jsx-runtime";
function ClearButton() {
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "clear-button-internal",
    onClick: () => {
      dispatch(clearFilters());
      dispatch(clearSearchTerms());
    },
    size: "xs",
    use: "tertiary-light",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "clear-button-label",
      message: "app.common.clear"
    })
  });
}
export default /*#__PURE__*/memo(ClearButton);